import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { handleFetchMe } from '../../actions/users';

const PrivateRoute = ({
  component: Component, handleFetchMe, user, ...rest
}) => {
  const token = localStorage.getItem('token');
  if (token && token !== undefined && !user.id && !user.error) {
    handleFetchMe(token);
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        localStorage.getItem('token') ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      )}
    />
  );
};

function mapStateToProps(state) {
  return {
    user: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    handleFetchMe,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/containers/PrivateRoute/index.js